import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import * as validators from '@flows/configs/shared/validators'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LegalBasis3BasicRolandDe } from '@flows/insurance/schemas'

const STEP_NAME = 'previous_contract_cancellation_date'

const legal_insurance_cancellation_date = (params: StepConfigParams) =>
  ({
    schema: validators.createPreprocessedCancellationDateSchema(
      schemaUtils.generateZodObjectFromPaths({
        [params.helperFunctions.getParamPath(STEP_NAME)]:
          BaseSchema_LegalBasis3BasicRolandDe.shape.previous_contract_cancellation_date.unwrap(),
      }),
      params,
      STEP_NAME
    ),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.legal_3.insurance_cancellation_date.title',
        },
      },
      {
        type: 'date',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('previous_contract_cancellation_date'),
        disabledIfValueExists: true,
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.legal_3.insurance_cancellation_date.infoText',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'legal_tenant',
  }) as const satisfies AnyStepConfiguration

export default legal_insurance_cancellation_date
